<script setup lang="ts">
defineProps<{ label: string; icon: string }>();
defineEmits<{ click: [] }>();
</script>

<template>
  <UButton
    class="w-full justify-center pointer-events-auto rounded-md ring-2 ring-white"
    color="blue"
    :leading-icon="icon"
    @click="$emit('click')"
  >
    {{ label }}
  </UButton>
</template>
